import React from "react";
import { CustomSwiper } from "../../";
import { CubeCard } from "../../";
import localData from "../../../localData";

export default function Skills() {
    const { html, css,sass,bootstrap, javascript, react, figma,node } = localData.images;
    const skills = [
        { title: "HTML", icon: html },
        { title: "CSS", icon: css },
        { title: "javascript", icon: javascript },
        { title: "sass", icon: sass },
        { title: "react", icon: react },
        { title: "figma", icon: figma },
        { title: "bootstrap", icon: bootstrap },
        { title: "node", icon: node },
        { isHidden: true },
    ];

    return (
        <section className="skills" id='skills' data-lazy-block>
            <div className="container-fluid">
                <h2 className="skills-title" data-lazy="fade">
                    skills
                </h2>

                <CustomSwiper
                    items={skills}
                    Card={CubeCard}
                    options={{
                        autoplay: {
                            enabled: true,
                            delay: false,
                            stopOnLastSlide: true,
                            waitForTransition: true,
                            pauseOnMouseEnter: false,
                        },
                    }}
                />
            </div>
        </section>
    );
}
